import React from 'react';
import { Error as ErrorIcon, Replay as ReplayIcon } from '@material-ui/icons';
import { Button, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useDefaultErrorStyles } from './styles';

import { Card, CardBody } from '../Card';

const DefaultError = ({ cleanError }) => {
  const classes = useDefaultErrorStyles();

  return (
    <Card>
      <CardBody className={classes.root}>
        <ErrorIcon className={classes.icon} />
        <Typography variant="body1">Oops, an error has occurred. Please try again reloading the page</Typography>
        <Button
          className={classes.button}
          onClick={cleanError}
          variant="outlined"
          color="primary"
          endIcon={<ReplayIcon />}
        >
          Reload
        </Button>
      </CardBody>
    </Card>
  );
};

DefaultError.propTypes = {
  cleanError: PropTypes.func.isRequired,
};

export default DefaultError;
